import React from 'react';
import AttachmentInputBase from './AttachmentInputBase';

const DEFAULT_FILE_ACCEPT = {
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'text/plain': ['.txt', '.csv']
};

const FileInput = (props) => (
  <AttachmentInputBase
    {...props}
    accept={props.accept ?? DEFAULT_FILE_ACCEPT}
    baseUrl="rest/file/"
    previewType="file"
    resourceFieldName="file"
    singleItemLabel="file"
    multipleItemLabel="files"
  />
);

export default FileInput;
